import LandingPageHeader from "../Components/AiComponents/modules/landing/Header";
import Section from "../Components/AiComponents/modules/landing/Section";
import LandingLayout from "../layouts/LandingLayout";

function LandingPage() {
  return (
    <>
      <LandingLayout>
        <LandingPageHeader />
        <span className="w-screen h-[1px] relative top-[9px] z-10 bg-stroke1 !px-0 md:hidden"></span>
        <Section />
      </LandingLayout>
    </>
  );
}

export default LandingPage;
